
export function getCountryCode(country) {
    switch (country) {
        case 'United States':
            return 242;
        case 'Australia':
            return 13
        default: break;
    }
}

export function isDropdownCountry(country) {
    return country === 'Australia' || country === 'United States';
}

export function getStateFromCode(countryCode, stateCode, contactDetails) {
    const states = contactDetails.states[countryCode];
    const state = states.find(state => stateCode === state.Code);
    return state.Description;
}

export function getStateFromId(countryCode, stateId, contactDetails) {
    const states = contactDetails.states[countryCode];
    const state = states.find(state => stateId === state.Id);
    return state ? state.Description : '';
}

export function isStateDescription(countryCode, stateDesp, contactDetails) {
    const states = contactDetails.states[countryCode];
    const state = states.find(state => stateDesp === state.Description);
    return state !== undefined;
}

// the combination of checking if country and state is fetched
export function countryStateFetched(selectedCountry, contactDetails) {
    // if countries are fetched
    const countriesFetched = contactDetails.countries.length > 0;
    // if the country is not US OR Australia
    let stateFetched = false;
    // no need to fetched data
    if (selectedCountry !== 'Australia' && selectedCountry !== 'United States') stateFetched = true;
    else {
        let countryId = getCountryCode(selectedCountry);
        stateFetched = contactDetails.states[countryId] !== undefined;
    }
    return countriesFetched && stateFetched;
}